<template>
    <div class="a-dialog dialog">
        <div class="dialog__inner">
            <slot name="icon">
                <svg-icon
                    v-if="icon"
                    original
                    :name="`navigation/${icon}`"
                    class="dialog__icon"
                />
            </slot>
            <span class="dialog__text">
                <slot>
                    {{ text }}
                </slot>
            </span>
            <div class="dialog__arow"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ADialog',
    props: {
        text: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: null
        }
    }
}
</script>

<style lang="scss">
@import "a-dialog";   
</style>